import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
}
export class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
export class InvalidInvitationError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidInvitationError";
    }
}
export class InvalidInvitationSecretError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidInvitationSecretError";
    }
}
export class ExpiredInvitationError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "ExpiredInvitationError";
    }
}
export class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
export class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
export class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
export class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
export default {
    GenericError,
    InvalidParameterError,
    InvalidInvitationError,
    InvalidInvitationSecretError,
    ExpiredInvitationError,
    NotFoundError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
